import { Component } from "react";
import View from "./view";
import "./index.css";
import PropTypes from "prop-types";
import { swapMachineStore } from "../../../backend/machines";

class MachineSwap extends Component {
  constructor(props) {
    super(props);
    this.state = { storeSelect: { value: null, label: null } };
    this._selectStore = this._selectStore.bind(this);
    this._swap = this._swap.bind(this);
  }
  render() {
    return View.call(this);
  }

  _selectStore(store) {
    this.setState({ storeSelect: store });
  }

  async _swap(event) {
    const storeId = this.state.storeSelect.value;
    const machineId = this.props.machineId;
    const toolId = this.props.toolId;
    await swapMachineStore(machineId, storeId, toolId);
    if (this.props.closeDialog) {
      this.props.closeDialog(event, true);
    }
  }
}

MachineSwap.propTypes = {
  machineId: PropTypes.number.isRequired
};

export default MachineSwap;



// WEBPACK FOOTER //
// ./src/screens/machines/machine-swap/index.js